<template>
  <div class="graph-block">
    <div class="graph-area graph-area__KeywordMap">
      <div class="sticky_scroll">
        <perfect-scrollbar
          :options="{
            suppressScrollX: false,
            suppressScrollY: true,
            minScrollbarLength: 10
          }"
        >
          <div class="graph-area graph-area__KeywordMap-position">
            <ListItemTrendMap
              v-for="(item, index) in data.items"
              :key="index"
              :item="item"
              ref="text"
            />
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
import ListItemTrendMap from '@/components/contentPlans/ListItemTrendMap';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
export default {
  props: ['keyword', 'project', 'words'],

  components: {
    ListItemTrendMap,
    PerfectScrollbar
  },

  data() {
    return {
      data: {
        items: []
      }
    };
  },

  watch: {
    words: {
      handler(value, oldValue) {
        if (!oldValue || value.length !== oldValue.length) {
          this.init();
        } else {
          for (let i = 0; i < value.length; i++) {
            if (value[i].text !== oldValue[i].text) {
              this.init();
              break;
            }
          }
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    init() {
      if (!this.words.length) {
        return;
      }
      this.data.items = JSON.parse(JSON.stringify(this.words));
      this.$nextTick(() => {
        for (let i = 0; i < this.data.items.length; i++) {
          let obj = Object.assign({}, this.data.items[i]);
          let position = this.getPosition(i);
          obj.left = position.left;
          obj.top = position.top;
          obj.height = position.height;
          obj.width = position.width;
          this.data.items.splice(i, 1, obj);
        }
      });
    },

    getPosition(index) {
      if (!this.$refs.text[index]) {
        return;
      }
      let text = this.$refs.text[index];
      let width = text.$el.clientWidth;
      let height = text.$el.clientHeight;
      let left = null;
      let top = null;

      if (index === 0) {
        left = 250 - width / 2;
        top = 150 - height / 2;
      } else {
        let position = this.getRandomPosition(index, width, height);
        left = position.left;
        top = position.top;
      }
      return {
        // leftがマイナスの数値になると文字が見切れてしまうので、0以下にならないようにする
        left: Math.max(left, 0),
        top: top,
        width: width,
        height: height
      };
    },
    getRandomPosition(index, width, height) {
      let left = ((Math.random() + Math.random()) / 2) * (400 - 0 + 1) + 0;
      let top = ((Math.random() + Math.random()) / 2) * (300 - 0 + 1) + 0;

      for (let i = 0; i < index; i++) {
        if (
          Math.abs(this.data.items[i].left - left) <
            this.data.items[i].width / 2 + width / 2 &&
          Math.abs(this.data.items[i].top - top) <
            this.data.items[i].height / 2 + height / 2
        ) {
          // キーワードが重なったら再配置
          return this.getRandomPosition(index, width, height);
        }
      }
      return {
        left: left,
        top: top
      };
    }
  }
};
</script>
